import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class MondayFirstDayDateAdapter extends NativeDateAdapter {
    // 0 = Sunday, 1 = Monday
    override getFirstDayOfWeek(): number {
        return 1;
    }
}
